function getFormdata(target){
  var form = document.getElementById('aad-quiz');
  var formData = new FormData(form);
  formData.append('action', 'questionnaire_submission');

  $.ajax({
    url: customSettings.ajaxurl,
    type: 'POST',
    processData: false,
    contentType: false,
    data: formData,
    success: function(data){
      nextPanel(target);
      cleanUpErrorMessages();
    }
  });
}

function finalSubmit(target){
  var form = document.getElementById('aad-quiz');
  var formData = new FormData(form);
  formData.append('action', 'questionnaire_submission');
  var successLocation = target.attr('data-redirect');

  $.ajax({
    url: customSettings.ajaxurl,
    type: 'POST',
    processData: false,
    contentType: false,
    data: formData,
    success: function(data){
      window.location.href = successLocation;
    }
  });
}
//if input is valid, load next panel, else block progression.
//first create function that moves to next panel on click
//then validation checks

//move to next panel if ajax is successful
function nextPanel(target, enableNext = true) {
  var current_section = target.closest('.quiz-section');
  var current_id = current_section.data('quiz-index');
  setCookie('questionnaire_last_entered', current_id, 7);
  var next_section = current_section.next();

  quizTrackerUpdate(current_id);

  current_section.fadeOut(0);
  if (enableNext) {
    toggleSectionFieldset(current_section);
  }
  next_section.fadeIn(0);
  if (enableNext) {
    toggleSectionFieldset(next_section);
  }
}

function cleanUpErrorMessages(){
  $('#aad-quiz fieldset .error').remove();
}

if ($('#aad-quiz').hasClass('is-filled')) {
  $('.quiz-advance').addClass('quiz-no-submit').removeClass('quiz-advance').removeAttr('id').prop('disabled', false);
  $('.quiz-no-submit').last().on('click', function(event) {
    event.preventDefault();
    window.location.href = ($(this)).data('redirect');
  })
  $('#aad-quiz fieldset').prop('disabled', true);
  $('#aad-quiz .radio-button').addClass('disabled');
}

$('.quiz-no-submit').on('click', function(event) {
  event.preventDefault();
  nextPanel($(this), false);
})

$('.quiz-advance').not('#quiz-start').not('#quiz-complete').click(function(event) {
  event.preventDefault();
  getFormdata($(this));
});

$('#quiz-start').click(function(event) {
  event.preventDefault();
  nextPanel($(this));
  cleanUpErrorMessages();
});

$('#quiz-complete').on('click', function(event) {
  event.preventDefault();

  var $self = $(this);

  grecaptcha.ready(function() {
    grecaptcha.execute(customSettings.recaptcha_site_key, {action: 'submit'}).then(function(token) {
      var email = $('#quiz-section-individual_details input[name="email"]').val();
      setCookie('questionnaire_email', email, 7);

      finalSubmit($self);
    });
  });
})



$('.quiz-section').on('keypress', function(event) {
  if (event.key === "Enter") {
    event.preventDefault();
    submitButton = $(this).find('.quiz-advance');
    if (submitButton.prop('disabled') === false) {
      submitButton.click();
    }
  }
});

function toggleSectionFieldset(section) {
  var $section = $(section);
  var $fieldset = $section.find('fieldset');
  $fieldset.prop('disabled', !$fieldset.prop('disabled'));
}


// getCookie('questionnaire_last_entered');


//if cookie is set, load last entered panel
//else load first panel
//check if form is complete

// if (getCookie('questionnaire_last_entered') !== '') {
//   var last_entered = getCookie('questionnaire_last_entered');
//   var last_entered_section = $('.quiz-section').eq(last_entered);
//   last_entered_section.fadeIn();
// } else {
//   var first_section = $('.quiz-section').eq(0);
//   first_section.fadeIn();
// }

function setHiddenValue(target) {
  target.closest('.quiz-section').find('.radio-hidden-value').val(target.attr('value')).trigger('change');
}

$('.quiz-section .radio-button').click(function() {
  // if not active, make active
  if (!$(this).hasClass('disabled')) {
    if (!$(this).hasClass('active')) {
      $(this).addClass('active').parent().siblings().find('.radio-button').removeClass('active');
    }
    setHiddenValue($(this));
  }
});

$('#quiz-start').click(function(event) {
  $('#quiz-steps').css("display", "flex");
  $('#quiz-steps').hide();
  $('#quiz-steps').fadeIn();
});

function quizTrackerUpdate(currentID) {
  $('#quiz-steps').find('[data-number="' + (currentID + 1) + '"]').addClass('step--active');
  $('#quiz-steps').find('[data-number="' + (currentID) + '"]').removeClass('step--active').addClass('step--complete');
}